import { useSelector } from "react-redux";

import { hasLiveSubscription } from "seneca-common/features/subscriptions/state";

import { createSearchParams, Filters } from "features/course-discovery/utils";
import { isNativeAppiOS } from "features/pwa/mobile/ios/utils/isNativeAppiOS";
import useGenerateCourseFilters from "features/teachers/hooks/useGenerateCourseFilters";

import { linkToClassPage } from "../../links";

export function linkToAddCoursesPage(classId?: string) {
  return `${linkToClassPage(classId)}/add-courses`;
}

function linkToAddClassCoursesWithQueryParams(
  classId: string,
  filters: Filters
): string {
  return `${linkToAddCoursesPage(classId)}?${createSearchParams(filters)}`;
}

export function useGetLinkToAddClassCourses() {
  const userHasSubscription = useSelector(hasLiveSubscription);

  let filters: Filters = {};
  if (!(userHasSubscription || isNativeAppiOS())) filters.price = "Free";

  return (classId: string) =>
    linkToAddClassCoursesWithQueryParams(classId, filters);
}

export function useLinkToAddClassCourses({ classId }: { classId: string }) {
  const filters = useGenerateCourseFilters(classId);

  return linkToAddClassCoursesWithQueryParams(classId, filters);
}
